import { all, put, takeEvery, select, call } from 'redux-saga/effects';
import { change, doSubmit, startSubmit, stopSubmit, reset } from 'circe/forms/actions';

import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { FORM_NAME } from './constants';
import { triggerEvent } from './api';

function* doTriggerEvent(context, action) {
  if (action.payload.name !== FORM_NAME) return;

  yield put(startSubmit(FORM_NAME));
  const {
    payload: {
      values: {
        events,
        itineraryId,
        locationId,
        locationInfo,
        stopItems,
        lateReason,
        clearTripId,
        successMessage,
        startForm,
        stopForm,
        formDone,
      },
    },
  } = action;

  const locationType = locationInfo.find((item) => item.id === locationId)?.type;

  try {
    startForm();

    const response = yield triggerEvent(
      events,
      itineraryId,
      locationId,
      stopItems,
      lateReason,
      locationType,
    );
    yield put(reset(FORM_NAME));
    yield put(
      showNotification(
        successMessage ||
          I18n.str('WaybillDocScannedSuccessfully', 'Waybill Document Scanned Successfully'),
        'success',
      ),
    );

    formDone();
    clearTripId();
  } catch (e) {
    yield put(
      showNotification(
        e?.response?.message || I18n.str('error', 'Something Went Wrong, Please try again'),
        'error',
      ),
    );
    console.error(e);
  } finally {
    stopForm();
    yield put(stopSubmit(FORM_NAME));
  }
}

function* watcher(context) {
  yield all([takeEvery(doSubmit().type, doTriggerEvent, context)]);
}

export default watcher;
